import { render, staticRenderFns } from "./HomeSlider.vue?vue&type=template&id=2b417b5a&scoped=true"
import script from "./HomeSlider.vue?vue&type=script&lang=js"
export * from "./HomeSlider.vue?vue&type=script&lang=js"
import style0 from "./HomeSlider.vue?vue&type=style&index=0&id=2b417b5a&prod&scoped=true&lang=css"
import style1 from "./HomeSlider.vue?vue&type=style&index=1&id=2b417b5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b417b5a",
  null
  
)

export default component.exports